import axiosInstance from "@/utils/axiosInstance";
import { clearCache } from "@/store/modules/storeCache";

const baseUrl = `api/public/mountings`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  readByToken({ commit }, payload: { token: string }) {
    return axiosInstance.get(`${baseUrl}/${payload.token}`, { params: {} })
      .then((data) => data.data);
  },
  update({ commit, state }, payload: {
    token: string,
    mounting: any,
    boxes: any[],
  }) {
    return axiosInstance.put(`${baseUrl}/${payload.token}`, payload)
      .then((data) => {
        return data.data;
      });
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
